import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Modal       from 'app/components/common/modal';
import UndoButton  from 'app/components/common/undo-button';
import FxRatesDuck from 'app/ducks/fx-rates';
import currencies  from 'app/helpers/currencies';

const UNDO_DUR = 7000;

class ModalConfirmLoad extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showUndo: false,
    };

    this.onCloseModal = this.onCloseModal.bind(this);
    this.onClickConfirm = this.onClickConfirm.bind(this);
    this.onConfirmDo = this.onConfirmDo.bind(this);
    this.onConfirmUndo = this.onConfirmUndo.bind(this);
  }

  componentDidMount() {
    this.props.fetchFxRates();
  }

  onCloseModal() {
    this.props.onClose();
  }

  onClickConfirm() {
    this.setState({showUndo: true});
  }
  onConfirmDo() {
    this.setState({showUndo: false});
    this.props.onConfirm();
  }
  onConfirmUndo() {
    this.setState({showUndo: false});
  }

  renderError() {
    const { loadError } = this.props;
    if (!loadError) return null;
    const reason = loadError.stripeMessage
      ? `Message from processor: ${loadError.stripeMessage}`
      : loadError.statusCode >= 500
        ? 'An internal server error has occurred. Please try again later.'
        : null;

    return (
      <div className="modal-wal-confirm-error">
        <p>Oops! We couldn't process your payment.</p>
        {reason && <p>{reason}</p>}
      </div>
    );
  }

  renderFx() {
    const {currencyCode, amount, toUsdFmt} = this.props;
    if (currencyCode === 'USD') return null;
    const usdFmt = toUsdFmt(currencyCode, amount);
    return (
      <p className="modal-wal-confirm-desc">Your donation will be added to your wallet balance in USD. Estimated amount: {`~${usdFmt || '...'}`}</p>
    );
  }

  render() {
    const { showUndo } = this.state;
    const { amount, loadPending, loadError, currencyCode } = this.props;
    const confirmDisabled = !!(loadPending || loadError || showUndo);
    const confirmLabel = (() => {
      if (showUndo) return 'Waiting...';
      if (loadPending) return 'Confirming...';
      return 'Confirm Transaction';
    })();
    const currency = currencies.byCode[currencyCode];
    let amountFmt = currency.format(amount);
    const isNonUsd = currencyCode !== 'USD';
    if (isNonUsd) amountFmt += ` ${currencyCode}`;

    return (
      <Modal className="modal-wal-confirm" onClose={this.onCloseModal}>
        <h1 className="modal-wal-confirm-heading">Almost there!</h1>
        <p className="modal-wal-confirm-desc">
          Upon confirmation, you will receive your tax-deductible receipt.
          <br />
          Please confirm your wallet upload below to start using the funds to donate to the nonprofits on Millie:
        </p>
        <p className="modal-wal-confirm-amount">
          {amountFmt}
        </p>
        {this.renderFx()}
        <button className="btn special jungle" onClick={this.onClickConfirm} disabled={confirmDisabled}>{confirmLabel}</button>
        {showUndo && (
          <UndoButton waitMs={UNDO_DUR} onDo={this.onConfirmDo} onUndo={this.onConfirmUndo} className="modal-wal-confirm-undo" />
        )}
        {this.renderError()}
      </Modal>
    );
  }

}

ModalConfirmLoad.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  currencyCode: PropTypes.string.isRequired,
  loadPending: PropTypes.bool.isRequired,
  loadError: PropTypes.object,
};

const stateToProps = (state) => ({
  toUsdFmt: FxRatesDuck.Slx.toUsdFmt(state),
});

const dispatchToProps = (dispatch) => ({
  fetchFxRates: () => dispatch(FxRatesDuck.Ax.fetchLatest()),
});

export default connect(stateToProps, dispatchToProps)(ModalConfirmLoad);
